// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_ptS0G {
  min-width: 100% !important;
  height: 40px;
}

.root_X2C88 {
  position: relative;
  flex-grow: 1;
}

.content_UHMAq { 
  overflow-y: hidden;
  overflow-x: auto;
}

.table_KUPzX {
  padding-bottom: 20px;
}

.bayNameHeader_CwPxY {
  height: 44px;
}

.headerCell_eJCMz {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  background-color: var( --color-base025, #F9FAFB );
}

.centerLinearHeader_QcsYx {
  display: flex;
  height: 25px;
  align-items: center;
}

.prep_MmWE1.really_i2K6Y.win_eylwt, .prep_MmWE1.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stagePrepBdr );
  background-color: var( --color-stagePrepBg );
}

.layup_wHGFx.really_i2K6Y.win_eylwt, .layup_wHGFx.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stageLayupBdr );
  background-color: var( --color-stageLayupBg );
}

.infusion_RCLVU.really_i2K6Y.win_eylwt, .infusion_RCLVU.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stageInfusionBdr );
  background-color: var( --color-stageInfusionBg );
}

.inspection_jeJ1S.really_i2K6Y.win_eylwt, .inspection_jeJ1S.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stageInspectionBdr );
  background-color: var( --color-stageInspectionBg );
}

.webAndClose_fHpZ3.really_i2K6Y.win_eylwt, .webAndClose_fHpZ3.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stageWebBdr );
  background-color: var( --color-stageWebBg );
}

.inactive_wmv8P.really_i2K6Y.win_eylwt, .inactive_wmv8P.really_i2K6Y.win_eylwt:hover {
  border-color: var( --color-stageInactiveBdr );
  background-color: var( --color-stageInactiveBg );
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineStageGanttChart/GanttTableSplitView.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD","sourcesContent":[".row {\n  min-width: 100% !important;\n  height: 40px;\n}\n\n.root {\n  position: relative;\n  flex-grow: 1;\n}\n\n.content { \n  overflow-y: hidden;\n  overflow-x: auto;\n}\n\n.table {\n  padding-bottom: 20px;\n}\n\n.bayNameHeader {\n  height: 44px;\n}\n\n.headerCell {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: flex;\n  background-color: var( --color-base025, #F9FAFB );\n}\n\n.centerLinearHeader {\n  display: flex;\n  height: 25px;\n  align-items: center;\n}\n\n.prep.really.win, .prep.really.win:hover {\n  border-color: var( --color-stagePrepBdr );\n  background-color: var( --color-stagePrepBg );\n}\n\n.layup.really.win, .layup.really.win:hover {\n  border-color: var( --color-stageLayupBdr );\n  background-color: var( --color-stageLayupBg );\n}\n\n.infusion.really.win, .infusion.really.win:hover {\n  border-color: var( --color-stageInfusionBdr );\n  background-color: var( --color-stageInfusionBg );\n}\n\n.inspection.really.win, .inspection.really.win:hover {\n  border-color: var( --color-stageInspectionBdr );\n  background-color: var( --color-stageInspectionBg );\n}\n\n.webAndClose.really.win, .webAndClose.really.win:hover {\n  border-color: var( --color-stageWebBdr );\n  background-color: var( --color-stageWebBg );\n}\n\n.inactive.really.win, .inactive.really.win:hover {\n  border-color: var( --color-stageInactiveBdr );\n  background-color: var( --color-stageInactiveBg );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_ptS0G`,
	"root": `root_X2C88`,
	"content": `content_UHMAq`,
	"table": `table_KUPzX`,
	"bayNameHeader": `bayNameHeader_CwPxY`,
	"headerCell": `headerCell_eJCMz`,
	"centerLinearHeader": `centerLinearHeader_QcsYx`,
	"prep": `prep_MmWE1`,
	"really": `really_i2K6Y`,
	"win": `win_eylwt`,
	"layup": `layup_wHGFx`,
	"infusion": `infusion_RCLVU`,
	"inspection": `inspection_jeJ1S`,
	"webAndClose": `webAndClose_fHpZ3`,
	"inactive": `inactive_wmv8P`
};
export default ___CSS_LOADER_EXPORT___;
